import ForgotPassword from './forgot-password.component';

export default [
  { path: '/forgot-password', name: 'forgot-password', component: ForgotPassword, exact: true },
];
